import { useEffect, useMemo, useState } from 'react';
import { dashboardApi } from '@/domains/traffic-monitoring/apis/dashboard';
import type { GoboImageData } from '@/domains/traffic-monitoring/types/dashboard.types';
import Button from '@/shared/components/ui/Button';
import { URLS } from '@/shared/config/urls';

interface ModalProjectorProps {
  isOpen?: boolean;
  onClose: () => void;
  goboImageId?: number | null;
}

const ModalProjector = ({ isOpen, onClose, goboImageId }: ModalProjectorProps) => {
  const [goboImages, setGoboImages] = useState<GoboImageData[]>([]);

  useEffect(() => {
    if (!isOpen) return;
    dashboardApi.getGoboImageList().then((res) => {
      setGoboImages(res.data ?? []);
    });
  }, [isOpen]);

  const selectedImage = useMemo(() => {
    if (!goboImageId) return null;
    return goboImages.find((img) => img.gobo_image_id === goboImageId);
  }, [goboImages, goboImageId]);

  const previewUrl = useMemo(() => {
    const path = selectedImage?.gobo_image_path?.replace(/^\/+/, '');
    if (!path) return '';
    return `${URLS.BACK_DSH}/common/image/${path}`;
  }, [selectedImage]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[1000]">
      <div className="w-fit flex flex-col gap-[25px] p-[40px] bg-db-card border border-[#D6DBE1] rounded-[5px]">
        <span className="h3bold">로고젝터 이미지</span>
        <div className="w-full items-center justify-center flex">
          {previewUrl ? (
            <img
              src={previewUrl}
              alt={selectedImage?.gobo_image_name || 'gobo-preview'}
              className="aspect-[16/9] object-cover w-full max-w-[500px] rounded-md"
            />
          ) : (
            <div className="aspect-[16/9] w-full max-w-[500px] rounded-md bg-gray-200 flex items-center justify-center text-gray-500">
              이미지가 설정되지 않았습니다
            </div>
          )}
        </div>
        {selectedImage && (
          <p className="text-center text-sm text-[var(--font-color)]">
            {selectedImage.gobo_image_name}
          </p>
        )}
        <div className="flex flex-row justify-center gap-[7px]">
          <Button customButton="btn-search-dark" label="닫기" onClick={onClose} />
        </div>
      </div>
    </div>
  );
};

export default ModalProjector;
